import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseSubscriberAdsComponent } from '../../abstract-components/base-subscriber-ads.component';

@Component({
  selector: 'subscriber-ads-card',
  standalone: false,
  templateUrl: './subscriber-ads-card.component.html',
  styleUrl: './subscriber-ads-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdsCardComponent extends BaseSubscriberAdsComponent {}
